import { render, staticRenderFns } from "./ThesisPattern.vue?vue&type=template&id=1ae00456"
import script from "./ThesisPattern.vue?vue&type=script&lang=js"
export * from "./ThesisPattern.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports